<template>
  <div class="challengesuggestion" v-if="challenge">
    <div v-if="challenge.motivator" id="suggested-theme-motivator" class="message">
      {{ challenge.motivator }} {{ $t('challenges:motivator-cta-text') }}
    </div>
    <div v-else id="suggested-theme-motivator" class="message">
      {{ $t('challenges:motivator-cta-text') }}
    </div>

    <div class="choices">
      <div @click="openSuggestedChallenge()" class="suggestion" id="theme-suggestion">
        <p id="suggested-theme-title" class="text-center">{{ challenge.title }}</p>
        <div class="viewButton text-center">
          <router-link v-if="challenge.id" :to="{ name: 'Challenge', params: { themeId: challenge.themeId, challengeId: challenge.id }}">{{$t('common:view')}}</router-link>
        </div>
      </div>
    </div>
    <div class="choices">
      <b-button :to="{ name: 'Challenges'}">{{$t('challenges:browse-other-themes')}}</b-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ChallengeSuggestion',
  data () {
    return {
      challenge: null
    }
  },
  mounted: async function () {
    await this.loadSuggestion()
  },
  watch: {
    language: {
      immediate: false,
      handler (newVal, oldVal) {
        this.loadSuggestion()
      }
    }
  },
  computed: {
    ...mapGetters(['language', 'challengeCategories', 'account'])
  },
  methods: {
    openSuggestedChallenge: function () {
      this.$router.push({ name: 'Challenge', params: { themeId: this.challenge.themeId, challengeId: this.challenge.id } })
    },
    loadSuggestion: function () {
      return this.axios(`/challenges/suggest?lang=${this.language}`).then((response) => {
        this.challenge = response.data.challenge
      })
    }
  }
}
</script>

<style lang="scss">

.suggestion {
  width: 100%;

  @media (min-width: 576px) {
    width: auto;
  }
  @media (min-width: 768px) {
    width: auto;
  }
  @media (min-width: 992px) {
    width: auto;
  }
  @media (min-width: 1200px) {
    width: auto;
  }

  display: inline-block;
  background-color: #4ce0b3;
  // background-color: #e3f5f9;
  // background-repeat: no-repeat;
  // background-image: url('/img/background-logo.svg'), radial-gradient(circle at center center,rgba(white,0.8), rgba(white,0.6)), radial-gradient(circle at bottom right,#b7e3ef, #9bdbec);
  // background-size: cover;
  // background-position: center;
  border-radius: 24px;
  box-shadow: 0 3px 6px rgba(black, 0.1);
  margin-bottom: 1rem;
  padding: 12px 18px;
  color: #377771;
  &:hover {
    cursor: pointer;
  }
  #suggested-theme-title {
    color: #377771;
    font-size: 1.25rem;
    margin: 0;
    padding: 1rem 1rem 1.5rem 1rem;
    font-weight: normal;
  }
  a {
    font-weight: bold;
  }
  .viewButton {
    margin: 0 -18px -12px -18px;
    padding: 12px 18px;
    background: white;
    border-radius: 0 0 24px 24px;
    a:hover {
      text-decoration: none;
    }
  }
  .themesuggestion {
    padding: 0px;
  }
}
</style>
